import { render, staticRenderFns } from "./FormUpdateUser.vue?vue&type=template&id=04daff89&"
import script from "./FormUpdateUser.vue?vue&type=script&lang=js&"
export * from "./FormUpdateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports